<template>
  <HActionDialog>
    <template #header>
      <div class="owner-modal__header">
        <WTitle size="small"> Quer sair da conversa?</WTitle>
        <WButton icon="icClose" variant="tertiary" icon-button @click="close" />
      </div>
    </template>

    <template #content>
      <WParagraph class="owner-modal__details">
        Você não poderá mais ler ou enviar mensagens, tendo acesso somente à
        plano e comentários.
      </WParagraph>
      <WParagraph>Escolha alguém para te substituir como líder:</WParagraph>
      <div
        v-for="staff in staffs"
        :key="staff.id"
        class="owner-modal__staff"
        :class="{
          'owner-modal__staff--selected': staff.id === selectedStaff
        }"
        @click="selectedStaff = staff.id"
      >
        <WAvatar size="small" :url="staff.photoURL" />

        <span>
          {{ staff.fullName }}
          -
          {{ staff.description }}
        </span>

        <strong v-if="staff.id === selectedStaff"> Líder </strong>
      </div>

      <footer class="owner-modal__actions">
        <WButton
          :loading="saving"
          :disabled="!selectedStaff || saving"
          @click="leaveChannel"
        >
          Sair da Conversa
        </WButton>
        <WButton variant="tertiary" @click="close"> Cancelar </WButton>
      </footer>
    </template>
  </HActionDialog>
</template>

<script>
import {
  WAvatar,
  WButton,
  WParagraph,
  WTitle
} from '@alice-health/wonderland-vue'
import { mapState } from 'vuex'

import { HActionDialog } from '@/components/shared/atoms'
import { mapStaffAsArray } from '@/utils/channel'

export default {
  name: 'ModalLeaveAndChangeOwnerChannel',
  components: {
    WButton,
    HActionDialog,
    WTitle,
    WParagraph,
    WAvatar
  },
  props: {
    channelId: { type: String, required: true },
    channelStaff: {
      type: Object,
      default: () => ({})
    }
  },
  emits: ['confirm', 'close'],
  data() {
    return {
      selectedStaff: undefined,
      saving: false
    }
  },
  computed: {
    ...mapState('user', ['user']),
    staffs() {
      const staffArray = mapStaffAsArray(this.channelStaff)
      return staffArray.filter(staff => staff.id !== this.user.id)
    }
  },
  methods: {
    async leaveChannel() {
      this.saving = true

      const owner = await this.$store.dispatch(
        'pillars/channel/giveOwnership',
        {
          channelId: this.channelId,
          staffId: this.selectedStaff
        }
      )

      if (!owner) {
        return
      }

      const removed = await this.$store.dispatch(
        'pillars/channel/removeStaffFromChannel',
        {
          channelId: this.channelId,
          staffId: this.user.id
        }
      )
      if (removed) {
        this.$emit('confirm')
      }
    },
    close() {
      this.$emit('close')
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/style/_non-rendering';
.owner-modal {
  background-color: var(--gl-color-shades-white);
  border-radius: var(--gl-border-radius-md);
  box-shadow: var(--gl-shadow-level-04);
  overflow: hidden;
  position: relative;
  width: 478px;

  &__header {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  &__container {
    @extend %body-default;
    padding: var(--gl-spacing-06) var(--gl-spacing-08);
  }

  &__actions {
    display: flex;
    gap: var(--gl-spacing-06);
    margin-top: var(--gl-spacing-06);

    button:last-of-type {
      flex: 1;
    }
  }

  &__details {
    margin-bottom: var(--gl-spacing-02);
  }

  &__staff {
    @extend %body-small;
    align-items: center;
    border-radius: var(--gl-border-radius-sm);
    border: 1px solid var(--gl-color-shades-gray-20);
    cursor: pointer;
    display: grid;
    gap: var(--gl-spacing-04);
    grid-template-columns: auto 1fr auto;
    margin-top: var(--gl-spacing-04);
    padding: var(--gl-spacing-02) var(--gl-spacing-04);
    position: relative;

    &:hover {
      background-color: var(--gl-color-shades-gray-10);
    }

    &--selected {
      border: 1px solid var(--gl-color-shades-magenta-60);
      color: var(--gl-color-shades-magenta-60);
    }
  }
}
</style>
